import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Sub/navbar";
import About from "./Sub/about";
import Portfolio from "./Sub/porfolio";
import Footer from "./Sub/footer";
import Button from "./Sub/Btns/Bigbtn";
import SubtitleCarousel from "./Sub/Carrusell";
import WhatsAppButton from "./Sub/wa"
import Accordion from "./Sub/FAQ";
import Counter from "./Sub/Counter";
import "./Css/Home.css";

const Portfolio1 = [
  {
    src: "/Proyects/16.webp",
    alt: "Project 4",
    link: "https://extremas.com.ar/",
    className: "span-4",

  },
  {
    src: "/Proyects/2.webp",
    srcSm: "/Proyects/2-sm.webp",
    alt: "Project 2",
    link: "https://www.laferneteria.com/",
    className: "span-2",
  },
  {
    src: "/Proyects/3.webp",
    alt: "Project 3",
    link: "https://kentucky.com.ar/",
    className: "span-3",
  },
  {
    src: "/Proyects/1.webp",
    alt: "Project 1",
    link: "https://heladeriacadore.com.ar/",
    className: "span-1",

  },
  {
    src: "/Proyects/5.webp",
    alt: "Project 5",
    link: "https://www.lacallebar.com/",
    className: "span-5",
  },
  {
    src: "/Proyects/7.webp",
    srcSm: "/Proyects/7-sm.webp",
    alt: "Project 6",
    link: "https://21deseptiembre.com/",
    className: "span-6",
  },
  {
    src: "/Proyects/6.webp",
    alt: "Project 7",
    link: "https://www.hipoalergic.com/",
    className: "span-7",

  },
];
const Portfolio2 = [
  {
    src: "/Proyects/9.webp",
    alt: "Project 1",
    link: "https://www.grupofiorasiesquel.com.ar/",
    className: "span-10",
  },
  {
    src: "/Proyects/10.webp",
    alt: "Project 1",
    link: "https://2",
    className: "span-9",
  },
  {
    src: "/Proyects/8.webp",
    alt: "Project 1",
    link: "https://audec.com.ar_",
    className: "span-5",
  },
  {
    src: "/Proyects/12.webp",
    alt: "Project 1",
    link: "https://jazzvoyeur.com.ar",
    className: "span-8",
  },
  {
    src: "/Proyects/15.webp",
    alt: "Project 1",
    link: "https://tiendacesviauto.com.ar/",
    className: "span-9",

  },
  {
    src: "/Proyects/14.webp",
    alt: "Project 1",
    link: "https://www.martinblust.com/",
    className: "span-10",

  },
  {
    src: "/Proyects/4.webp",
    alt: "Project 4",
    link: "https://blackgym.onrender.com/home",
    className: "span-4",

  },
  {
    src: "/Proyects/13.webp",
    alt: "Project 1",
    link: "https://www.caseih.com_es-ar_argentina_productos_tractores",
    className: "span-2",
  },
  {
    src: "/Proyects/17.webp",
    alt: "Project 1",
    link: "https://tingladosargentina.com.ar/",
    className: "span-2",

  },
  {
    src: "/Proyects/11.webp",
    alt: "Project 1",
    link: "https://peabody.com.ar/",
    className: "span-5",

  },
  {
    src: "/Proyects/19.webp",
    alt: "Project 1",
    link: "https://starseg.com.ar/",
    className: "span-2",

  },
  {
    src: "/Proyects/18.webp",
    alt: "Project 1",
    link: "https://selmadigital.com",
    className: "span-1",

  },
]

const App = () => {
  const NosotrosRef = useRef(null);
  const ProyectosRef = useRef(null);
  const ProcesoRef = useRef(null);
  const PlanesRef = useRef(null);
  const navigate = useNavigate();

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const NavContacto = () => {
    navigate("/contacto");
  }

  return (
    <>
      <Navbar
        onScrollToNosotros={() => scrollToSection(NosotrosRef)}
        onScrollToProyectos={() => scrollToSection(ProyectosRef)}
        onScrollToProceso={() => scrollToSection(ProcesoRef)}
        onScrollToPlanes={() => scrollToSection(PlanesRef)}
      />
      <div className="container text-center mt-4 header">
        <img src={"/Logos/logo.svg"} className="imgs" alt="Website Logo" />
        <h1 className="para">ClustTec</h1>
        {/* <h1 className="title-h">Desarrollo Web</h1> */}
        <SubtitleCarousel />
        <div style={{ margin: "20px" }}>
          <Button onClick={NavContacto}>Contactanos</Button>
        </div>
        {/* <HoverButton  /> */}
      </div>
      {/* <VerticalCarousel/> */}
      <div ref={NosotrosRef} />
      <About />
      <div ref={ProyectosRef} />
      <Portfolio tiles={Portfolio1} />

      <Accordion defaultOpen={[0]} />

      <div ref={ProcesoRef} />
      {/* <Proceso /> */}
      <div ref={PlanesRef} />
      {/* <Planes /> */}
      <div style={{ margin: "20px", alignSelf: "center", justifySelf: "center" }}>
        <Button onClick={NavContacto}>Escribinos ➤ </Button>
      </div>

      {/* <Counter end={200} duration={2000} /> */}

  {/*     <Portfolio tiles={Portfolio2} /> */}

      {/* <Partners /> */}
      <WhatsAppButton />
      <Footer />
    </>
  );
};

export default App;
